import { ReactNode } from 'react';

interface ActionCardMetaProps {
	children: ReactNode;
}

export function ActionCardMeta({ children }: ActionCardMetaProps) {
	return <span className='c-action-card__meta'>{children}</span>;
}
